import type { SVGProps } from 'react';

const SvgCompare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M11 3c-.55 0-1 .45-1 1H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1m7 1h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c1.65 0 3-1.35 3-3V7c0-1.65-1.35-3-3-3"
    />
  </svg>
);
export default SvgCompare;
